import type { AxiosError } from "axios";
import type { Reducer, ReducersMapObject } from "redux";
import { combineReducers } from "redux";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import { RequestStatus } from "../../types/api";
import { actions } from "../api/actions";

export type ApiCall = {
  status: RequestStatus;
  error?: AxiosError | Error;
};
export type ApiState = Record<AsyncActionKey, ApiCall>;

const apiCallInit: ApiCall = {
  status: RequestStatus.NONE,
};

type AsyncAction = ActionType<typeof actions>;
type AsyncActionReducer = Reducer<ApiCall, AsyncAction>;
type AsyncActionKey = keyof typeof actions;

const asyncActionReducer = (key: AsyncActionKey): AsyncActionReducer => {
  return (state: ApiCall = apiCallInit, action: AsyncAction) => {
    switch (action.type) {
      case getType(actions[key].request):
        return {
          status: RequestStatus.FETCHING,
        };
      case getType(actions[key].success):
        return {
          status: RequestStatus.SUCCESS,
        };
      case getType(actions[key].failure):
        return {
          status: RequestStatus.FAILURE,
          error: action.payload,
        };
      default:
        return state;
    }
  };
};

export const apiActionKeys = Object.keys(actions) as Array<AsyncActionKey>;
const asyncReducers = apiActionKeys.reduce<
  ReducersMapObject<ApiState, AsyncAction>
>(
  (acc, key) => {
    return {
      ...acc,
      [key]: asyncActionReducer(key),
    };
  },
  {} as Record<AsyncActionKey, AsyncActionReducer>,
);

export const api: Reducer<ApiState, AsyncAction> = combineReducers(
  asyncReducers,
) as unknown as Reducer<ApiState, AsyncAction>;
